import { Component, Input } from '@angular/core';

@Component({
  selector: 'store-need-help',
  template: '@if (needHelp) {<section class="resize" [innerHTML]=needHelp></section>}',
  styleUrls: ['./need-help.component.scss'],
  standalone: false,
})
export class NeedHelpComponent {
  @Input() needHelp: string;
}
